<div *ngIf="bulkPayload">
	<nz-table nzSize="small" [nzData]="[1]" [nzFrontPagination]="false">
		<thead>
			<tr>
				<th>Channel</th>
				<th *ngIf="bulkPayload.bulk && bulkPayload.bulk.subject">Subject</th>
				<th>Message</th>
			</tr>
		</thead>
		<tbody>
			<tr>
				<td class="vertical-align-top">{{bulkPayload.bulk ? bulkPayload.bulk.channel : ''}}</td>
				<td class="vertical-align-top" *ngIf="bulkPayload.bulk && bulkPayload.bulk.subject">{{bulkPayload.bulk.subject}}</td>
				<td class="preserve-whitespace">{{bulkPayload.bulk ? bulkPayload.bulk.body : ''}}</td>
			</tr>
		</tbody>
	</nz-table>
	<div class="row gap-1">
		<div class="col">
			<nz-divider [nzText]="recipientFilterTitle" nzOrientation="center"></nz-divider>
			<app-filter-info [filters]="bulkPayload.filters"></app-filter-info>
		</div>
		<div class="col">
			<nz-divider nzText="Delivery & Schedule" nzOrientation="center"></nz-divider>
			<nz-table nzSize="small" [nzData]="[1]" [nzFrontPagination]="false">
				<thead>
					<tr>
						<th>Delivery Report</th>
						<th>Scheduled</th>
						<th>Description</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>{{bulkPayload.trigger ? 'Yes' : 'No'}}</td>
						<td>{{bulkPayload.bulk ? bulkPayload.bulk.deliveryReport ? 'Yes' : 'No' : ''}}</td>
						<td>{{bulkPayload.trigger ? bulkPayload.trigger.description : ''}}</td>
					</tr>
				</tbody>
			</nz-table>
		</div>
	</div>
	<nz-divider nzText="Attachments" nzOrientation="left"></nz-divider>
	<nz-table nzSize="small" [nzData]="[1]" [nzFrontPagination]="false">
		<thead>
			<tr>
				<th>File name</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let file of bulkPayload.attachments">
				<td>{{file.fileName}}</td>
			</tr>
		</tbody>
	</nz-table>
	
	<div class="inline-flex gap-2">
		<button nz-button nzType="primary" class="me-2" (click)="onConfirm()">Confirm</button>
		<button nz-button nzType="default"  (click)="onCancel()">Cancel</button>
	</div>
</div>